// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"AddToSlackAction-primaryButton-6fTunw","addAction":"AddToSlackAction-addAction-3p_ODP","addIcon":"AddToSlackAction-addIcon-2Ka1bA"};